import { render, staticRenderFns } from "./appVoice.vue?vue&type=template&id=5f5e6fea&scoped=true"
import script from "./appVoice.vue?vue&type=script&lang=js"
export * from "./appVoice.vue?vue&type=script&lang=js"
import style0 from "./appVoice.vue?vue&type=style&index=0&id=5f5e6fea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5e6fea",
  null
  
)

export default component.exports